import { FlattenedShorcut } from "modules/shortcuts/models";
import React, { MouseEvent, useState } from "react";
import DropZone from "./dropZone";
import { useDragReorder } from "modules/common/hooks/useDragReorder";
import DraggableNameContainer from "./draggableNameContainer";

interface IDraggableFlatShortcutsFormatProps {
    flattenedFormat: FlattenedShorcut[];
    onDrop: (itemToMoveIdx: number, moveToItemId?: string, moveToitemIdx?: number) => void;
    onGroupMouseDown: (id: string) => void;
    onMouseMove: (e: MouseEvent, isDragging: boolean) => void;
}

const DraggableFlatShortcutsFormat: React.FC<IDraggableFlatShortcutsFormatProps> = ({
    flattenedFormat,
    onDrop,
    onGroupMouseDown,
    onMouseMove
}) => {
    const [flattenedShortcutDragged, setFlattenedShortcutDragged] = useState<number | null>(null);

    const onItemDrop = (itemId?: string, itemIdx?: number) => {
        if (flattenedShortcutDragged === null) return;
        
        onDrop(flattenedShortcutDragged!, itemId, itemIdx);
        setFlattenedShortcutDragged(null);
    }
    
    const { mousePos, dropIdx } = useDragReorder({
        enabled: true,
        items: flattenedFormat,
        draggedIdx: flattenedShortcutDragged,
        onDrop: onItemDrop,
        dropZoneClassName: "drop-zone",
        mouseHandlerComponentClassName: "shortcut-group-list"
    });

    const onMouseDown = (index: number, flattenedShortcut: FlattenedShorcut) => {
        if (flattenedShortcut.isGroup){
            onGroupMouseDown(flattenedShortcut.id);
        }
        else {
            document.body.style.cursor = "move";
            setFlattenedShortcutDragged(index);
        }
    }

    return <React.Fragment>
        <DropZone isHidden/>
        {
            flattenedFormat
                .map((fs, idx) => {
                    const isFloating = flattenedShortcutDragged === idx;

                    return <React.Fragment key={fs.id}>
                        <DraggableNameContainer 
                            divClassName={fs.isGroup ? "shortcut-group-name-div" : "shortcut-name-div"} 
                            floatingClassName={!fs.isGroup && isFloating ? "shortcuts-floating" : ""} 
                            divStyle={{
                                left: isFloating ? mousePos.left - 13 : 'initial',
                                top: isFloating ? mousePos.y - 93 : 'initial',
                                width: isFloating ? '100%' : 'initial',
                            }} 
                            name={fs.name} 
                            nameClassName={fs.isGroup ? "shortcut-group-name" : "shortcut-name"} 
                            iconClassName="shortcuts-drag-indicator"
                            onMouseDown={() => onMouseDown(idx, fs)}
                            onMouseMove={e => onMouseMove(e, flattenedShortcutDragged !== null)}
                        />
                        {flattenedShortcutDragged !== idx && <DropZone isHidden={flattenedShortcutDragged === null || dropIdx !== idx + 1} />}
                    </React.Fragment>;
                })
        }
    </React.Fragment>;
};

export default DraggableFlatShortcutsFormat;
